import type { ExperimentsData } from '@/components/_shared/contexts/ExperimentsContext';
import { LISTINGS_VIBE_FIRST_EXPERIMENT } from '../../common/constants';

export type StylesMap = Record<string, string>;

export function isVibeFirstVariantActiveFromExperiments(experiments: ExperimentsData | undefined): boolean {
  if (!experiments) {
    return false;
  }
  return experiments[LISTINGS_VIBE_FIRST_EXPERIMENT.experimentName]?.groupName?.toLowerCase() === 'test';
}

export const getVariantStyles = <T extends StylesMap>(
  isVariantActive: boolean,
  defaultStyles: T,
  variantStyles?: T,
): T => {
  return isVariantActive && variantStyles ? variantStyles : defaultStyles;
};
